export enum MemberRoutesNamesEnum {
  member = 'member',
  memberInformation = 'member-information',
  memberProjects = 'member-projects',
  memberSettings = 'member-settings'
}
